
import {User} from '@/interfaces/user';
import {Options, Vue} from 'vue-class-component';
import MenuItem from '@/components/menu-item/menu-item.vue';

@Options({
  name: 'app-menu-sidebar',
  components: {
    'app-menu-item': MenuItem
  }
})
export default class MenuSidebar extends Vue {
  public menu = MENU;

  get user(): User {
    return this.$store.getters['auth/user'];
  }

  get sidebarSkin() {
    return this.$store.getters['ui/sidebarSkin'];
  }
}

export const MENU = [
  // {
  //   name: 'menus.dashboard',
  //   path: '/',
  //   icon: 'fa-tachometer-alt'
  // },
  {
    name: 'menus.users',
    path: '/users',
    icon: 'fa-users'
  },
  {
    name: 'menus.customers',
    path: '/customers',
    icon: 'fa-user-tie'
  },
  {
    name: 'menus.customersDevices',
    path: '/customers-devices',
    icon: 'fa-laptop'
  },
  {
    name: 'menus.customersDevicesLogs',
    path: '/customers-devices-logs',
    icon: 'fa-stethoscope'
  },
  // {
  //   name: 'menus.chat',
  //   path: '/chat',
  //   icon: 'fa-comments'
  // }
  // {
  //     name: 'labels.mainMenu',
  //     children: [
  //         {
  //             name: 'labels.subMenu',
  //             path: '/sub-menu-1'
  //         },
  //
  //         {
  //             name: 'labels.blank',
  //             path: '/sub-menu-2'
  //         }
  //     ]
  // }
];
